import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { notEmpty } from 'utils/ramdaAdditions';

export const PersonAddressBlock = ({ address }) => notEmpty(address) ? (
    <div>
        <DefinitionHeader translate="person.address.title" iconType="map-marker" />
        <dl className="dl-horizontal panel-view">
            <dd>
                { address.map((address, index) => (
                    <div className='adress-item' key={index}>
                        <div className='adress-type'>{address.name}</div>
                        <div className='adress-text'>{address.address}</div>
                    </div>
                ))}
            </dd>
        </dl>
    </div>
) : null;
